// Global auth middleware  -  protects ALL routes except login
// Uses useCookie which works on both server and client

export default defineNuxtRouteMiddleware(async (to) => {
  const { user, fetchUser, clearSession } = useAuth();

  // Public pages (no auth required)
  if (to.path === '/login' || to.path === '/forgot-password') {
    if (user.value && await fetchUser() && to.path === '/login') {
      return navigateTo('/');
    }
    return;
  }

  if (!await fetchUser()) {
    return navigateTo({
      path: '/login',
      query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
    });
  }

  // Check admin role
  const role = user.value?.role;
  if (!['admin', 'super_admin', 'warehouse_staff'].includes(role as string)) {
    // Clear invalid session
    clearSession();
    return navigateTo('/login');
  }
});
